<ng-content [class.fade-in]="isPageLoaded"></ng-content>
<div #spinner class="spinner" [class.fade-out]="isPageLoaded">
  <ion-spinner></ion-spinner>
  <p sxTextSize="medium">{{displayText}}</p>
</div>

